// Vendor imports
const { connect } = require('react-redux')
// Common client-v2 imports
const deferDispatch = require('client-v2/common/state/dispatch')
// Entry imports
const articleProfileModalActions = require('../state/modal-actions')
const ArticleProfileModal = require('./modal-dumb')

function mapStateToProps(state) {
  const modalState = state.articleProfileModal
  if (!modalState) {
    return {
      isVisible: false,
      currentIndex: 0,
      modalDepth: 0,
      slideCount: 0
    }
  }
  return {
    isVisible: true,
    currentIndex: modalState.currentIndex,
    modalDepth: modalState.depth,
    slideCount: modalState.slides.size
  }
}

function mapDispatchToProps(dispatch) {
  const { dispatchAction } = deferDispatch(dispatch)
  return {
    onClose: dispatchAction(articleProfileModalActions.hide),
    onSlideRefresh: dispatchAction(articleProfileModalActions.currentIndexDidChange),
    onSwipeLeft: dispatchAction(articleProfileModalActions.previousSlide),
    onSwipeRight: dispatchAction(articleProfileModalActions.nextSlide)
  }
}

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps
)(
  ArticleProfileModal
)
